module.exports = __webpack_public_path__ + "static/media/icon-filetype-pdf.e81d10f0.svg";